import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { FEATURE_SCOPES } from '@data/auth';
import { FeatureToggle, ToggleOff, ToggleOn } from '@components/common/atoms';
import { remoteMonitoringSettingAtom } from '@data/fms/environment/states';
import DriveNotification from '@components/common/DriveNotification';
import CallReceiver from '@components/common/CallReceiver';
import { usePostAuthorizationAPI } from '@api/auth';
import { MediaClient } from '@tier4/webauto-media-client';

const RemoteMonitoringNotification: React.FC = () => {
  const remoteMonitoringSettings = useAtomValue(remoteMonitoringSettingAtom);
  const getToken = usePostAuthorizationAPI();
  const [isAuthTokenCallbackReady, setIsAuthTokenCallbackReady] =
    useState(false);

  useEffect(() => {
    console.log('RemoteMonitoringNotification useEffect');
    const getter = async () => {
      const token = await getToken();
      return {
        token: token.accessToken,
        expiredAt: new Date(token.expiry * 1000),
      };
    };
    MediaClient.addAuthTokenCallback(getter);
    // RemoteClient.addAuthTokenCallback(getter);
    setIsAuthTokenCallbackReady(true);
    return () => {
      console.log('RemoteMonitoringNotification useEffect cleanup');
      MediaClient.removeAuthTokenCallback(getter);
      // RemoteClient.removeAuthTokenCallback(getter);
      setIsAuthTokenCallbackReady(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // MediaClient.addAuthTokenCallback の登録完了後にレンダリングする
  if (!isAuthTokenCallbackReady) return;

  return (
    <FeatureToggle type="featureScope" scope={FEATURE_SCOPES.InternalProject}>
      <ToggleOn>
        {remoteMonitoringSettings?.value.notification ? (
          <DriveNotification />
        ) : (
          <CallReceiver />
        )}
      </ToggleOn>
      <ToggleOff>
        <CallReceiver />
      </ToggleOff>
    </FeatureToggle>
  );
};

export default RemoteMonitoringNotification;
